/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box } from '@mui/material';
import { FieldArray, FormikProvider, getIn, useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { IS_SA } from '../../../../../config/appConfig';
import { AppRoutes } from '../../../../../constants/appRoutes';
import { FormHelper } from '../../../../../helpers/formHelper';
import { buildLocalizeRoute } from '../../../../../helpers/languageHelper';
import {
	getRegistrationData,
	saveTokenFromRegistration,
	setRegistrationData,
	updateInvestorSteps
} from '../../../../../services/authService';
import { ArrowIcons } from '../../../../../shared/components/common/arrowIcons';
import { ButtonWrapper } from '../../../../../shared/components/formUtilities/useButton';
import { InputWrapper } from '../../../../../shared/components/formUtilities/useInput';
import SelectWrapper from '../../../../../shared/components/formUtilities/useSelect';
import { TextWrapper } from '../../../../../shared/components/formUtilities/useTextWrapper';
import { RadioWrapper } from '../../../../../shared/components/formUtilities/userRadioButton';
import { InvestorRegPersonalInfoExtraSchema } from '../../../../../shared/validations/schema';
import { SubStepper } from '../../../components/subStepper';
import { InvestorRegService } from '../../investorRegService';
import { InvestorDeclarationDialog } from '../declarationDialog';

export const PersonalInformationExtra = ({
	onGoBack = () => { },
	onKSASubmit = () => { },
	onGoBackKSA = () => { },
	isRetailer = false,
	isSa = IS_SA,
}) => {
	const investorRegService = new InvestorRegService();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [searchParams, setSearchParams] = useSearchParams();
	const { investorCollections } = useSelector(
		(state) => state.investorCollectionReducer
	);
	const annualIncomes = investorCollections?.annualIncomeCollection || [];
	const investmentSources = investorCollections?.incomeSourceCollection || [];
	const professionalLevels =
		investorCollections?.professionalLevels || [];
	const industrySectors =
		investorCollections?.industrySectors || [];
	const estimatedYearlyInvestments =
		investorCollections?.estimateAnnualInvestmentCollection || [];
	const countries = investorCollections?.countryCollection || [];
	const netWorthCollection = investorCollections?.netWorthCollection || [];
	const publicFunctionList = investorCollections?.publicFunctionCollection || [];
	const crsWhyNotQuestionsList = investorCollections?.crsWhyNotQuestionsCollection || [];

	const [isIndustryRequired, setIsIndustryRequired] = useState(false);
	const [personalExtra, setPersonalExtra] = useState(null);
	const [loading, setLoading] = useState(false);
	const [showDeclarationPopup, setShowDeclarationPopup] = useState(false);

	const form = useFormik({
		initialValues: {
			publicFunction: FormHelper.buildOtherFormGroup(),
			employmentStatusId: '',
			industrySectorId: '',
			companyName: '',
			bankCountryId: '',
			industry: '',
			annualIncomeId: '',
			netWorthId: '',
			estimatedAnnualInvestmentId: '',
			jobTitle: '',
			incomeSource: '',
			termsConditionsForInvestmentsAccepted: isSa ? false : true,
			investmentContract: isSa ? false : true,
			taxResidencies: FormHelper.getTaxResidencies(),
		},
		onSubmit: (values) => {
			if (!form.values?.employmentStatusId || (isIndustryRequired && !form.values?.industrySectorId)) {
				return;
			}
			submit();
		},
		validationSchema: InvestorRegPersonalInfoExtraSchema,
		...FormHelper.formikProps(),
	});

	const employmentStatusId = getIn(form.values, "employmentStatusId");

	useEffect(() => {
		if (employmentStatusId === 14 || employmentStatusId === 15) {
			setIsIndustryRequired(false);
		} else {
			setIsIndustryRequired(true);
		}
	}, [employmentStatusId]);

	useEffect(() => {
		investorRegService
			.getInvestorPersonalInformationExtra()
			.then((resp) => {
				const params = new URLSearchParams(window.location.search);
				const countryOfResidenceId = params.get('c') ? parseInt(params.get('c')) : null;
				let data = resp.data;
				let personalInfo = {
					...data,
					publicFunction: FormHelper.getComplexOther(data?.publicFunction),
					bankCountryId: data?.bankCountry?.id,
					employmentStatusId: data?.employmentStatus?.id || null,
					annualIncomeId: data?.annualIncome?.id,
					netWorthId: data?.netWorth?.id,
					industrySectorId: data?.industrySector?.id || null,
					estimatedAnnualInvestmentId: data?.estimatedAnnualInvestment?.id,
					industry: FormHelper.getComplexOther(data?.industry),
					jobTitle: data?.jobTitle,
					hasExterienceInFinancialIndustry:
						data?.hasExterienceInFinancialIndustry || false,
					incomeSource: FormHelper.getComplexOther(data?.incomeSource),
					taxResidencies: FormHelper.getTaxResidencies(data?.taxResidencies),
				};
				if (countryOfResidenceId && (countryOfResidenceId === 1 || countryOfResidenceId === 2)) {
					if (personalInfo?.taxResidencies?.length === 1 && !personalInfo?.taxResidencies[0]?.countryId) {
						personalInfo.taxResidencies[0].countryId = countryOfResidenceId;
						personalInfo.taxResidencies[0].hasTaxId = false;
						personalInfo.taxResidencies[0].whyNotId = 1;
					}
				}
				setPersonalExtra(personalInfo);
				form.setValues(personalInfo);
			})
			.catch((err) => { });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onBack = () => {
		let data = {
			...getRegistrationData(),
			requestedStep: 1,
		};
		setRegistrationData(data);
		onGoBack();
	};

	const submit = () => {
		let formValue = form.values;
		setLoading(true);
		investorRegService
			.submitPersonalInformationExtra(formValue)
			.then((resp) => {
				setLoading(false);
				let registrationModel = resp.data?.registrationModel;
				saveTokenFromRegistration(resp.data?.loginModel?.token);
				let regData = {
					...getRegistrationData(),
					step: registrationModel.step,
					requestedStep: 2,
				};
				setRegistrationData(regData);
				updateInvestorSteps(registrationModel.step);
				if (isSa) {
					onKSASubmit();
				} else {
					navigate(
						buildLocalizeRoute(
							`${AppRoutes.InvestorRegistration}/${AppRoutes.iRegDocumentVarification}`
						)
					);
				}
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	return (
		<Box>
			{!isSa ? (
				<SubStepper
					stepName="personalInformation2"
					currentStep={2}
					totalSteps={2}
				/>
			) : null}
			<FormikProvider value={form}>
				<Box className="flex flex-col space-y-4">
					<Box className="grid grid-cols-1 md:grid-cols-2 gap-4">
						<SelectWrapper
							dataTestID='publicFunction'
							name={'publicFunction.valueId'}
							key={'publicFunction.valueId'}
							controlOtherValueName={'publicFunction.valueSpecified'}
							items={publicFunctionList}
							label={'importantPublicFunction'}
						/>
						<SelectWrapper
							externalErrorMessage={!form.values?.employmentStatusId ? 'required' : ''}
							errorStateTestID="employmentStatusIdError"
							name={'employmentStatusId'}
							key={'employmentStatusId'}
							items={professionalLevels}
							label={'employmentDetails'}
						/>
						<SelectWrapper
							externalErrorMessage={!form.values?.industrySectorId && isIndustryRequired ? 'required' : ''}
							name={'industrySectorId'}
							key={'industrySectorId'}
							items={industrySectors}
							label={'industry'}
						/>
						<Box className={`grid grid-cols-1 md:grid-cols-2 gap-4`}>
							<InputWrapper
								name={'companyName'}
								key={'companyName'}
								label={'companyName'}></InputWrapper>
							<InputWrapper
								name={'jobTitle'}
								key={'jobTitle'}
								label={'jobTitle'}></InputWrapper>
						</Box>
						<Box className='grid grid-cols-1 md:grid-cols-2 gap-4'>
							<SelectWrapper
								name={'incomeSource.valueId'}
								key={'incomeSource.valueId'}
								controlOtherValueName={'incomeSource.valueSpecified'}
								items={investmentSources}
								label={'fundingSourceOfInvestment'}
							/>
							<SelectWrapper
								errorStateTestID="annualIncomeIdError"
								name={'annualIncomeId'}
								key={'annualIncomeId'}
								items={annualIncomes}
								label={'annualIncome'}
							/>
						</Box>
						<Box className={`grid gap-4 grid-cols-1 md:grid-cols-2`}>
							<SelectWrapper
								errorStateTestID="netWorthIdError"
								tooltipId={'networthRegPersonalExtra'}
								tooltipText={'netWorthTooltipText'}
								name={'netWorthId'}
								key={'netWorthId'}
								items={netWorthCollection}
								label={'netWorth'}
							/>
							<SelectWrapper
								errorStateTestID="estimatedAnnualInvestmentIdError"
								name={'estimatedAnnualInvestmentId'}
								key={'estimatedAnnualInvestmentId'}
								items={estimatedYearlyInvestments}
								label={'estimatedYearlyInvestment'}
							/>
						</Box>
						<SelectWrapper
							name={'bankCountryId'}
							key={'bankCountryId'}
							items={countries}
							label={'bankCountry'}
						/>
						<SelectWrapper
							items={countries}
							name={`taxResidencies.${0}.countryId`}
							key={`taxResidencies.${0}.countryId`}
							label={t('taxResidency')}
						/>
						<SelectWrapper
							items={[{ name: "Yes", displayName: "Yes", id: true },
							{ name: "No", displayName: "No", id: false }
							]}
							name={`taxResidencies.${0}.hasTaxId`}
							key={`taxResidencies.${0}.hasTaxId`}
							label={t('doYouHaveTaxIdInThisCountry')}
						/>
						<Box className='flex items-center'>
							{form.values.taxResidencies[0]?.hasTaxId === true ? (
								<InputWrapper
									name={`taxResidencies.${0}.taxId`}
									key={`taxResidencies.${0}.taxId`}
									label={t('taxId')}></InputWrapper>
							) : form.values.taxResidencies[0]?.hasTaxId === false ? (
								<SelectWrapper
									items={crsWhyNotQuestionsList}
									name={`taxResidencies.${0}.whyNotId`}
									key={`taxResidencies.${0}.whyNotId`}
									label={t('whyNot')}
								/>
							) : null}
						</Box>
					</Box>
					<Box className={`flex justify-center md:justify-between`}>
						<ButtonWrapper
							dataTestID="backBtn"
							classList="!secondary-btn md:!mx-0 !mx-2"
							disabled={loading}
							largeBtn
							icon={<ArrowIcons isInvert></ArrowIcons>}
							label={t('back')}
							onClick={() => {
								if (isSa) {
									onGoBackKSA && onGoBackKSA();
								} else {
									onBack();
								}
							}}
						/>
						<ButtonWrapper
							dataTestID="nextBtn"
							loading={loading}
							largeBtn
							endIcon={<ArrowIcons></ArrowIcons>}
							label={t('next')}
							onClick={() => {
								FormHelper.validateForm(form);
							}}
						/>
					</Box>
					{showDeclarationPopup ? (
						<InvestorDeclarationDialog
							state={showDeclarationPopup}
							onClose={(e) => {
								setShowDeclarationPopup(false);
							}}></InvestorDeclarationDialog>
					) : null}
				</Box>
			</FormikProvider>
		</Box>
	);
};
